import React, { useEffect, useState } from 'react'
import creditline from "src/assets/images/credit-line-icon.svg";
import securedcheckout from "src/assets/images/secured-checkout-icon.svg";
import { Tooltip } from 'src/component/Global/Tooltip';
import CheckoutInvoiceAddress from './CheckoutInvoiceAddress';
import Constants from "../../helper/Constants";
import System from "../../helper/system";
import Helper from "../../helper/Helper";
import { profileStore } from "../../hooks/profile";
import CheckOut from '@system/config/checkout';
import useReduxState from 'src/hooks/useReduxState';
import { useOrderStore } from 'src/hooks/order';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';
import { useCartStore } from 'src/hooks/cart';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import AxiosIndicatorRunTimeLoader from 'src/component/Global/AxiosIndicatorRunTimeLoader';
import yellowAlert from "src/assets/images/yellow-alert.png";
import { __remove, __set } from "../../store/axios_indicator";
import { Beacon } from "../../component/Global/Beacon";
import {stepEventMaker} from "src/support/stepEventMaker";
import { useSelector } from "react-redux";
import { useProductInventoryPriceStore } from 'src/hooks/productInventoryPrice';

const CheckoutPaymentMethod = () => {
    const [paymentMethod, setPaymentMethod] = useState('');
    const [sameAsShipTo, setSameAsShipTo] = useState(true);
    const [invoiceDetail, setInvoiceDetail] = useState({});
    const [detailValidation, setDetailValidation] = useState({});
    const [orderValidation, setOrderValidation] = useState({});
    const [tnc, setTnc] = useReduxState(false, 'setTnc');
    const [__check] = useAxiosIndicatorCheck();
    const {
        countryCodes,
        purchaseOrderNumberPattern,
        addressType,
        paymentError,
        siteUser: { WEB, CORE },
        paymentType: { CreditCard, AvnetCredit },
        currencyType: { CAD, USD },
        checkOutSteps: { PAYMENT_STEP },
        taxExempt: { NONE },
        salesOrgC001,
        paymentTerms
    } = Constants;
    const { xiPaytScript } = System;
    const { storageName: { PAYMENT_ERROR,ORDER_FEEDBACK }, avUserInfoData: { currentUser, salesOrg } } = System
    const [{ countryList, profile_account_information, billing_addresses }, {
        get_country_list, get_state_list
    }] = profileStore();
    const [{ validate_order_from_server, place_order_item_list }, { }, { place_your_order }] = useOrderStore()
    const [{ CART_DATA,CART_SUB_TOTAL, CART_TAX_TARIFF,CART_PRODUCTS  }, { }, { add_compliance_data }] = useCartStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();
    const [shippingAddressInfo, setShippingAddressInfo] = useReduxState({}, 'setShippingAddressInfo')
    const [shippingMethodInfo, setShippingMethodInfo] = useReduxState({}, 'setShippingMethodInfo')
    const [paymentMethodInfo, setPaymentMethodInfo] = useReduxState({}, 'setPaymentMethodInfo')
    const [checkOutStepStatus, setCheckoutStepStatus] = useReduxState('', 'setCheckoutStepStatus')
    const [stateList, setStateList] = useState([]);
    const [ccTokenResponse, setCcTokenResponse] = useState({});
    const [{ }, { get_inventory_by_id }, { }] = useProductInventoryPriceStore();
   
    const onValueChange = (field, value) => {
        let updatedValue = value;
        if (field === 'stateCode') {
            updatedValue = countryCodes.includes(invoiceDetail?.countryCode)?stateList.find((state) => state.stateCode === value)?.stateCode : value;
        }
        const newInvoiceDetail = { ...invoiceDetail, [field]: updatedValue };
        setInvoiceDetail(newInvoiceDetail);
        if (isSubmitted) {
            onValidateData(newInvoiceDetail);
            setTnc(false)
        }
    };
    
    const [showAlert, setShowAlert] = useState(false)
    const [isSubmitted, setIsSubmitted] = useState(false)
    const isWebUser = currentUser === WEB
    const isSalesOrg = salesOrgC001 === salesOrg
    const [newShipTo, setNewShipTo] = useReduxState('', "setNewShipTo");
    const [checkoutData, setCheckoutData] = useReduxState({}, 'setCheckoutData')
    const isOnlySoftwareParts = CART_PRODUCTS && !Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === false);
    const [taxExemptDetails, setTaxExemptDetails] = useReduxState({taxExemptFile:'',taxExempt:NONE}, "setTaxExemptDetails");
    const [exportComplianceStatus, setExportComplianceStatus] = useReduxState(false, 'setExportComplianceStatus')
    const [paymentOptions, setPaymentOptions] = useState(false);
    
    useEffect(() => {
        async function fetchHere() {
            await get_country_list();
        }
        if (countryList?.length <= 0) {
            fetchHere()
        }
    }, [])

    useEffect(() => {
        if (isWebUser || paymentTerms.includes(validate_order_from_server?.paymentTerm?.code)) {
            setPaymentOptions(false);
            setPaymentMethod(CreditCard)
        } else {
            setPaymentOptions(true);
        }
    }, [validate_order_from_server])

    useEffect(() => {
        setCcTokenResponse(window.paymetric)
    }, []);


    useEffect(() => {
        async function fetchStateList() {
            if (countryCodes.includes(invoiceDetail?.countryCode)) {
                setStateList(await get_state_list(invoiceDetail.countryCode))
            }
        }

        fetchStateList()
    }, [invoiceDetail?.countryCode])

    const onValidateData = (invoiceDetail) => {
        let validationModal = {};
        if (!Helper.valueIsNotNull(invoiceDetail.addressLineOne)) {
            validationModal.addressLineOne = "A valid address is required.";
        }
        if (!Helper.valueIsNotNull(invoiceDetail.cityName)) {
            validationModal.cityName = "A valid city is required.";
        }
        if (!Helper.valueIsNotNull(invoiceDetail.postalCode)) {
            validationModal.postalCode = "A valid zip code is required.";
        }
        const isCountryCode = (Helper.valueIsNotNull(invoiceDetail.countryCode));
        if (!isCountryCode) {
            validationModal.countryCode = "A valid country is required.";
        }
        if (isCountryCode && countryCodes.includes(invoiceDetail.countryCode) && !Helper.valueIsNotNull(invoiceDetail.stateCode)) {
            validationModal.stateCode = "A valid State/Province is required.";
        }

        setDetailValidation(validationModal);
        return Object.keys(validationModal).length === 0;
    };
   
    useEffect(() => {
        if (ccTokenResponse) {
            function Iframe_OnLoad() {
                $XIFrame.onload({
                    iFrameId: 'DiFrameV2',
                    targetUrl: System.xiPayIFrameLink(ccTokenResponse),
                    storeCardAmount: true,
                    onCardTypeChange: function (e) {
                        console.log("iframe onLoad | onCardTypeChange: ", e)
                    },
                    onValidate: function (e) {
                        console.log("iframe onLoad | onValidate: ", e)
                    },
                    onLoadSuccess: function (e) {
                        console.log("iframe onLoad | onLoadSuccess: ", e)
                    },
                    onError: function (msg) {
                        console.log("iframe onLoad | onError: ", msg);
                        __remove("PLACE_ORDER_API_CALL");
                    },
                    onInvalidHandler: function (e) {
                        console.log("iframe onLoad | onInvalidHandler: ", e)
                        __remove("PLACE_ORDER_API_CALL");
                    },
                    amount: checkoutData?.orderTotal || 0
                    // amount: CART_SUB_TOTAL + (Number(CART_TAX_TARIFF.tax) || 0) + (Number(CART_TAX_TARIFF.tariff) || 0) + (Number(shippingMethodInfo.value) || 0),
                });
            }

            // Ensure the XIFrame script is loaded before calling Iframe_OnLoad
            if (window.$XIFrame) {
                Iframe_OnLoad();
            } else {
                const script = document.createElement('script');
                script.src = xiPaytScript;
                script.onload = () => Iframe_OnLoad();
                document.body.appendChild(script);
            }
        }
    }, [ccTokenResponse, CART_SUB_TOTAL, CART_TAX_TARIFF, checkoutData]);

    useEffect(() => {
        setInvoiceDetail(shippingAddressInfo?.address || {})
        setPaymentMethodInfo({ ...paymentMethodInfo, billingCurrency: isWebUser
            ? shippingAddressInfo?.address?.countryCode === 'CA' ? CAD : USD
            : isSalesOrg ? CAD : USD})
    }, [shippingAddressInfo?.id]);

    const onPlaceOrder = async (event) => {
        const { id, ...shippingMethodWithoutId } = shippingMethodInfo;
        const checkoutPayload = { ...checkoutData, currencyType: checkoutData.billingCurrency };
        delete checkoutPayload.billingCurrency;
        setIsSubmitted(true)
        const isValid = onValidate()
        const params = {
            "billTo": billing_addresses[0]?.id ? (paymentMethodInfo?.invoiceAddressType === addressType?.SHIP_TO ? shippingAddressInfo?.id : billing_addresses[0]?.id) : (shippingAddressInfo?.id || null),
            "shipToId": shippingAddressInfo && shippingAddressInfo.id ? shippingAddressInfo.id : '',
            "attn": shippingAddressInfo?.attn,
            "telephoneNumber": shippingAddressInfo?.telephoneNumber,
            "SoftwareDownloadEmail": shippingAddressInfo?.SoftwareDownloadEmail,
            "carrier": isOnlySoftwareParts?null:shippingMethodWithoutId,
            "wholeDelivery": true,
            "taxExempt": taxExemptDetails?.taxExempt,
            "taxExemptFileName": taxExemptDetails?.taxExemptFile,
            "pecEmail": place_order_item_list?.pecEmail,
            "purchaseOrderNumber": paymentMethodInfo?.purchaseOrderNumber || "",
            "sapQuoteNumber": place_order_item_list?.sapQuoteNumber,
            "orderBlock": false,
            "creditRisk": false,
            "orderPlaced": true,
            "paymentMethod": isWebUser ? CreditCard : paymentMethod,
            orderEstimationReq: checkoutPayload
        }

        if (isValid && (paymentMethod === CreditCard || isWebUser)) {
            if (window.$XIFrame) {
                __set("PLACE_ORDER_API_CALL");
                window.$XIFrame.submit({
                    iFrameId: "DiFrameV2",
                    targetUrl: System.xiPayIFrameLink(ccTokenResponse),
                    onSuccess: async function (e) {
                        e = JSON.parse(e)
                        if (e.data.HasPassed) {
                            const creditCardRequest = {
                                accessToken: ccTokenResponse.token,
                                firstName: profile_account_information.user.firstName,
                                lastName: profile_account_information.user.lastName,
                                billingAddress: {
                                    cardHolderAddress1: invoiceDetail.addressLineOne,
                                    cardHolderAddress2: invoiceDetail.addressLineTwo,
                                    cardHolderCity: invoiceDetail.cityName,
                                    cardHolderState: invoiceDetail.stateCode,
                                    cardHolderZip: invoiceDetail.postalCode,
                                    cardHolderCountry: invoiceDetail.countryCode,
                                }
                            }
                            params.creditCardRequest = creditCardRequest
                            // when success, need to call place_your_order with ccTokenResponse data
                            placeOrder(params)
                        } else {
                            console.error('iframe Error : hasPassed is False', e);
                            __remove("PLACE_ORDER_API_CALL");
                        }
                    },
                    onError: function (e) {
                        console.error('iframe Error submitting form', e);
                        __remove("PLACE_ORDER_API_CALL");
                    },
                    intcp3DSecure: function (e) {
                        console.log('iframe 3D Secure intercepted', e);
                        __remove("PLACE_ORDER_API_CALL");
                    }
                });
            } else {
                console.error('iframe $XIFrame library not loaded');
                __remove("PLACE_ORDER_API_CALL");
            }
        } else if (isValid && paymentMethod === AvnetCredit) {
            __set("PLACE_ORDER_API_CALL");
            placeOrder(params)
        }
    }

    const placeOrder = async (params) => {
        const invoiceAddress = paymentMethodInfo?.invoiceAddressType === addressType.BILL_TO ? billing_addresses[0] : shippingAddressInfo
        const orderAlertRequest = {
            isNewShipto: newShipTo === params.shipToId,
            isNewBillto: newShipTo === params.billTo
        }
        params.orderAlertRequest = orderAlertRequest;
        const response = await place_your_order(params)
        if (response?.paymentError) {
            __remove("PLACE_ORDER_API_CALL");
            localStorage.setItem(PAYMENT_ERROR, response?.paymentError);
            system_alert_indicator({
                name: 'placeOrderError',
                message: response?.paymentError,
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
            const url = new URL(window.location.href);
            if (!url.searchParams.has(paymentError)) {
                url.searchParams.set(paymentError, 'true');
            }
            window.location.replace(url.toString());

        } else if (response?.webOrderNumber) {
            localStorage.setItem(ORDER_FEEDBACK, true);
            const newUrl = `${CheckOut.getCheckOutStatusRouteURL()}?orderId=${response?.webOrderNumber}&currentCurrency=${checkoutData.billingCurrency}`;
            checkoutStep3();
            window.location.href = newUrl
        }else if (response?.message) {
            console.log("step3", newUrl)
            window.location.href = newUrl
        } else if (response?.message) {
            __remove("PLACE_ORDER_API_CALL");
            system_alert_indicator({
                name: 'placeOrderError',
                message: response?.message,
                type: "danger",
                isDisplay: true,
                isDisplayIcon: false
            })
        } else {
            __remove("PLACE_ORDER_API_CALL");
            system_alert_indicator({
                name: 'placeOrderError',
                message: "Order Submission failed. Please try again later.",
                type: "danger",
                isDisplay: false,
                isDisplayIcon: true
            })
        }
    }

    const c = System.getParams();
    const quoteNumber = c.quote_number;

    //By Ramya Kannan [Cart, quote Checkout-step1 ] 
    let quoteDetails = useSelector(
        (state) => state.entities.model_QuoteDetail.cart_quote_active_session
      );

    function checkoutStep3(){
        localStorage.setItem("adobeEventType","checkOut");
        let checkOutStep = "checkoutStep3";
        let cartData = [];
        Object.entries(CART_DATA).map((data,key)=>{
           cartData.push(data[1])
        })
        cartData.forEach((data,key)=>{
           let copyObj = {...data};
           copyObj.qas = get_inventory_by_id(copyObj.ItemNumber || copyObj.itemNumber)?.inventoryQty || copyObj.quantity;
           cartData[key] = copyObj;
         })
        stepEventMaker(cartData,quoteDetails,checkOutStep,quoteNumber);
    }

    const onValidate = () => {
        let showAlert = false;
        if (Helper.valueIsNotNull(paymentMethodInfo?.purchaseOrderNumber) && !Helper.validateRegex(paymentMethodInfo?.purchaseOrderNumber, purchaseOrderNumberPattern)) {
            orderValidation.purchaseOrderNumber = "A valid purchase order number is required.";
        } else {
            delete orderValidation.purchaseOrderNumber;
        }

        if (paymentOptions && !paymentMethod) {
            showAlert = true
            orderValidation.invoiceAddressType = "You must select a payment method.";
        } else {
            delete orderValidation.invoiceAddressType;
        }

        if (isWebUser) {
            if (!paymentMethodInfo?.invoiceAddressType) {
                showAlert=true
                orderValidation.invoiceAddressType = "Please select an invoice address";
            } else {
                delete orderValidation.invoiceAddressType;
            }
        }

        if (paymentMethod === AvnetCredit) {
            if (!paymentMethodInfo.purchaseOrderNumber) {
                orderValidation.purchaseOrderNumber = "The Purchase Order Number field cannot be empty.";
            } else {
                delete orderValidation.purchaseOrderNumber;
            }
        }

        setShowAlert(showAlert)
        setOrderValidation({ ...orderValidation })

        return Object.keys(orderValidation).length === 0 && (paymentMethod === CreditCard ? onValidateData(invoiceDetail) : true)
    }

    const renderStateListOnCountryChange = async (value) => {
        setStateList(await get_state_list(value))
    }

    const changeBillingCurrency = (value) => {
        setPaymentMethodInfo({ ...paymentMethodInfo, billingCurrency: value })
    }

    const ExportComplienceCallBack = async (data = null) => {
        if (data) {
            try {
                const complianceData = await add_compliance_data(data)
                if (complianceData?.isSuccessFull) {
                    setExportComplianceStatus(true)
                    setTnc(true)
                }
            } catch (error) {
                console.log("error in submitting form", error)
            }
        }
    }

    return (
        <div
            className={"shipping-address steps-inner mb-3 " + ((checkOutStepStatus === PAYMENT_STEP) ? 'active' : '')}>
            {__check(['VALIDATE_ORDER_API_CALL', 'VIEW_CART_API_CALL', 'SET_DEFAULT_SHIPPING_ADDRESS_API_CALL', 'CARRIER_OPTION_UPDATE', 'PLACE_ORDER_API_CALL']).status &&
                <AxiosIndicatorRunTimeLoader overlay={true} />}
            <div className="checkout-titles d-flex justify-content-between"><h2>3. Payment Method</h2></div>
            <div className='checkbox-steps-content'>
                {showAlert &&
                    <div className={'alert alert-danger'} role="alert">
                        <span><div>{orderValidation.invoiceAddressType}</div></span>
                        {!isWebUser && !paymentMethod ? <img className="ms-auto" src={yellowAlert} /> : <button type="button" className="close" data-dismiss="alert" aria-label="Close"
                            onClick={() => setShowAlert(false)}>
                            <span aria-hidden="true">&times;</span>
                        </button>}
                    </div>
                }
                <div className="bs5 row mb-3">
                    <div className="col-md-3">
                        <label htmlFor="BillCurrency"><h3 className='mt-0'>BILLING CURRENCY:</h3></label>
                        <div className='selectbox'>
                            <select className="form-control form-control-sm" value={paymentMethodInfo?.billingCurrency}
                                    disabled={isWebUser ? shippingAddressInfo?.address?.countryCode !== 'CA' : !isSalesOrg }
                                    onChange={(event) => {
                                        changeBillingCurrency(event.target.value);
                                    }} name="BillCurrency">
                                <option value={CAD}>CAD</option>
                                <option value={USD}>USD</option>
                            </select>
                        </div>
                    </div>
                </div>
                {paymentOptions && <>
                    <h3 className="mt-4">SELECT PAYMENT METHOD:</h3>
                    <ul className="mx-0 px-0 mt-2">
                        <li>
                            <div className="form-check mb-1">
                                <input className="form-check-input mt-1" type="radio" name="paymentMethod"
                                       id="payment1"
                                       value="option1" onChange={(e) => {
                                    setShowAlert(false);
                                    setPaymentMethod(AvnetCredit)
                                    delete orderValidation.purchaseOrderNumber;
                                    setOrderValidation({ ...orderValidation });
                                }}/>
                                <label className="form-check-label" htmlFor="payment1">Avnet Credit
                                    Line/ {profile_account_information.customerNo}</label>
                            </div>
                        </li>
                        <li>
                            <div className="form-check mb-1">
                                <input className="form-check-input mt-1" type="radio" name="paymentMethod"
                                       id="payment2"
                                       value="option2"
                                       onChange={async (e) => {
                                           setShowAlert(false);
                                           setCcTokenResponse(window.paymetric)
                                           setPaymentMethod(CreditCard)
                                           delete orderValidation.purchaseOrderNumber;
                                           setOrderValidation({ ...orderValidation })
                                       }}/>
                                <label className="form-check-label" htmlFor="payment2">Credit Card</label></div>
                        </li>
                    </ul>
                </>}
                {(paymentMethod === CreditCard) &&
                    <div className='creaditcard-method-container'>
                        <div className='guaranteed-checkout'>
                            <img src={securedcheckout} className="me-2" alt='Guaranteed Secure Checkout' />
                            GUARANTEED <strong>SECURE</strong> CHECKOUT
                        </div>
                        <div className='row'>
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                                {ccTokenResponse &&
                                    <iframe id="DiFrameV2" src={System.xiPayIFrameLink(ccTokenResponse)}
                                        style={{ minHeight: "340px", width: "100%", border: "0px" }}></iframe>}
                            </div>
                            <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 card-billing-address'>
                                <h3 className="mt-0">CARD BILLING ADDRESS</h3>
                                <div className="form-check mb-1">
                                    <input className="form-check-input mt-1" type="checkbox" name="shipre"
                                        id="carshipre1" checked={sameAsShipTo} onChange={(e) => {
                                            setSameAsShipTo(e.target.checked);
                                            if (e.target.checked) {
                                                setIsSubmitted(false)
                                                setDetailValidation({})
                                                setInvoiceDetail(shippingAddressInfo.address)
                                            } else {
                                                setIsSubmitted(false)
                                                setTnc(false)
                                                setInvoiceDetail({
                                                    addressLineOne: '',
                                                    addressLineTwo: '',
                                                    cityName: '',
                                                    countryCode: '',
                                                    stateCode: '',
                                                    postalCode: '',
                                                })
                                            }
                                        }}
                                    />
                                    <label className="form-check-label" htmlFor="carshipre1">Use Shipping Address as
                                        Credit
                                        Card Address</label>
                                </div>
                                <div className='bs5 row'>
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label className="form-label">Address 1*</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.addressLineOne ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder="Address 1"
                                                name="addressLineOne"
                                                value={invoiceDetail.addressLineOne || ''}
                                                onChange={(event) => {
                                                    onValueChange("addressLineOne", event.target.value);
                                                }}
                                                
                                                readOnly={sameAsShipTo}
                                            />
                                            {detailValidation.addressLineOne &&
                                                <p className="error">{detailValidation.addressLineOne}</p>}
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label className="form-label">Address 2</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder="Address 2"
                                                name="addressLineTwo"
                                                value={invoiceDetail.addressLineTwo || ''}
                                                onChange={(event) => {
                                                    onValueChange("addressLineTwo", event.target.value);
                                                }}
                                               
                                                readOnly={sameAsShipTo} />
                                          
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label className="form-label">City*</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.cityName ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder="City" name="cityName"
                                                value={invoiceDetail.cityName || ''}
                                                onChange={(event) => {
                                                    onValueChange("cityName", event.target.value);
                                                }}
                                               
                                                readOnly={sameAsShipTo} />
                                            {detailValidation.cityName &&
                                                <p className="error">{detailValidation.cityName}</p>}
                                        </div>
                                    </div>
                                    <div className='col-12'>
                                        <div className='form-group'>
                                            <label
                                                className="form-label">Country*</label>
                                            <select
                                                className={`form-control form-control-sm ${detailValidation.countryCode ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                name="countryCode"
                                                value={invoiceDetail.countryCode}
                                                onChange={({ target: { value } }) => {
                                                    onValueChange("countryCode", value);
                                                    setStateList([]);
                                                    setInvoiceDetail({
                                                        ...invoiceDetail, countryCode: value, stateCode: ''
                                                    });
                                                    if (countryCodes.includes(value)) {
                                                        renderStateListOnCountryChange(value)
                                                    }
                                                }}
                                                disabled={sameAsShipTo}
                                            >
                                                <option value="">Please Select</option>
                                                {countryList?.map((v, i) => (<option key={v.countryId}
                                                    value={v.countryCode}>{v.countryName}</option>))}
                                            </select>
                                            {detailValidation.countryCode &&
                                                <p className="error">{detailValidation.countryCode}</p>}
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='form-group'>
                                            <label htmlFor="stateCode"
                                                className="d-block">{stateList.length !== 0 && invoiceDetail?.countryCode ? 'State / Province*' : 'State / Province'}</label>
                                            {(stateList.length !== 0 && invoiceDetail?.countryCode) ? <>
                                                <select
                                                    className={`form-control form-control-sm ${detailValidation.stateCode ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                    name="stateCode"
                                                    value={invoiceDetail.stateCode}
                                                    onChange={({ target: { value } }) => onValueChange("stateCode", value)}
                                                    disabled={sameAsShipTo}
                                                >
                                                    <option value="">Select a state</option>
                                                    {stateList.map((v, i) => (<option key={v.stateId}
                                                        value={v.stateCode}>{v.stateName}</option>))}
                                                </select>
                                                {detailValidation.stateCode &&
                                                    <p className="error">{detailValidation.stateCode}</p>}
                                            </> : <input
                                                type="text"
                                                className={`form-control form-control-sm ${""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                id="stateCode"
                                                placeholder="State"
                                                name="stateCode"
                                                value={invoiceDetail.stateCode || ''}
                                                onChange={({ target: { value } }) => onValueChange("stateCode", value)}
                                                readOnly={sameAsShipTo}
                                            />}
                                        </div>
                                    </div>
                                    <div className='col-6'>
                                        <div className='form-group'>
                                            <label className="form-label">Zip / Postal Code*</label>
                                            <input type="text"
                                                className={`form-control form-control-sm ${detailValidation.postalCode ? "error" : ""} ${sameAsShipTo ? "readonly-field" : ""}`}
                                                placeholder="Zip / Postal Code"
                                                name="postalCode"
                                                value={invoiceDetail.postalCode || ''}
                                                onChange={(event) => {
                                                    onValueChange("postalCode", event.target.value);
                                                }}
                                               
                                                readOnly={sameAsShipTo} />
                                            {detailValidation.postalCode &&
                                                <p className="error">{detailValidation.postalCode}</p>}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>}
                {isWebUser && <div className='credit-line'>
                    <div className='credit-line-blackbox'>
                        <img src={creditline} className="" />
                        Credit Line
                    </div>
                    <div className='d-flex align-items-center w-100 apply-credit-line'>
                        <div><b className='d-block'>Apply For Credit Line </b> Use this payment option to ensure
                            that
                            your account is set up to have a Credit Line through Avnet.
                        </div>
                        <div className='ms-auto'>
                            <Beacon position={"top"} content={() => "Please send your Credit Line Application to OnlinesupportUS@Avnet.com"}
                                    opener={() => (
                                      <button type="button" className="bs5 btn btn-secondary btn-sm"><a
                                        className='text-green'
                                        href='https://www.avnet.com/wcsstore/AvnetSAS/StaticContent/AvnetCreditApplication.pdf'
                                        target="_blank"
                                        rel="noreferrer">Apply</a>
                                      </button>
                                    )}/>
                        </div>
                    </div>
                </div>}
                <hr className='p-0'></hr>
                {!isWebUser && <div className='credit-line-method mt-2 mb-2'>
                    <div className="shipping-additional-info step-complete-hide info-text"><p>Online payment options
                        include American Express, MasterCard, Visa and Discover. Credit cards will be authorized at
                        the
                        time of order and charged at the time of shipment. For parts that are backordered, your
                        credit
                        card will be authorized for the order total every 7 days but only charged when the order
                        ships.
                        For general questions about your order, please contact us at 1(800) 408-8353 (6am-6pm CST)
                        or <a
                            href="mainto:onlinesupportUS@avnet.com"> OnlineSupportUS@Avnet.com.</a></p></div>
                    <hr className='p-0'></hr>
                </div>}
                <CheckoutInvoiceAddress orderValidation={orderValidation} setOrderValidation={setOrderValidation}
                    setShowAlert={setShowAlert} />

                <div className='credit-line-method mt-2 mb-2'>
                    <div className="shipping-additional-info step-complete-hide info-text"><p>The exact freight amount
                        and Tax will be calculated at the time shipment is processed and will appear on your shipment
                        notifications.</p></div>
                </div>

                <div className='text-right mt-3 mb-3'>
                    <div className="form-check mb-2">
                        <label className="form-check-label">
                            <input className="form-check-input float-none me-1 border-black" type="checkbox" id="tc"
                                name="tnc"
                                onChange={(event) => {
                                    if(!exportComplianceStatus && ((paymentMethodInfo?.invoiceAddressType === addressType?.BILL_TO && billing_addresses[0]?.address?.countryCode !== 'US') || (invoiceDetail?.countryCode && invoiceDetail?.countryCode !== 'US'))) {   
                                        System.popup('ExportCompliance', { ExportComplienceCallBack });
                                    } else {
                                        setTnc(event.target.checked);
                                    }
                                }}
                                checked={tnc}
                                value={tnc}
                            />
                            <span className="p-l-05">*I have read and agree to the </span>
                        </label>
                        <a className="text-blue2 p-l-05"
                            href="https://www.avnet.com/wps/portal/us/about-avnet/terms-and-conditions-of-purchase/"
                            target="_blank" rel="noreferrer">terms and conditions</a>
                    </div>
                    {!tnc ? <Tooltip
                        position={'bottom center'}
                        opener={() => (
                            <span className="w150 ms-auto bs5 d-flex">
                                <button type="button" disabled={true} onClick={onPlaceOrder}
                                    className="bs5 btn btn-primary btn-sm mt-auto ms-auto w150">
                                    place order
                                </button>
                            </span>
                        )}
                        content={() => (
                            <p>Please select the checkbox to place the order.</p>
                        )}
                    /> : <button type="button" onClick={onPlaceOrder}
                        className="bs5 btn btn-primary btn-sm mt-auto d-block ms-auto w150">
                        place order
                    </button>
                    }
                </div>
            </div>
        </div>);
}

export default CheckoutPaymentMethod;